import styled, { css } from 'styled-components';

export const CardProduct = styled.div`
  display: flex;
  position: relative;
  height: 100%;
`;

export const CardProductInner = styled.div`
  ${({ theme }) => css`
    background: ${theme.v3.colors.neutral[100]};
    box-shadow: 0 5px 10px 0 rgba(223, 226, 235, 0.24), 0 4px 8px 0 rgba(223, 226, 235, 0.18);
    border-radius: 32px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    position: relative;
  `}
`;

export const CardProductImageWrapper = styled.div`
  ${({ theme }) => css`
    border-radius: ${theme.v3.border.radius.xl};
    overflow: hidden;
  `}
`;

export const CardProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CardProductBody = styled.div`
  ${({ theme }) => css`
    align-items: baseline;
    display: flex;
    flex-direction: column;
    padding: ${theme.v3.spacing.xxs};
  `}
`;

export const CardProductTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[30]};
    font-size: ${theme.v3.font.sizes.large};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.relaxed};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: 18px;
    }
  `}
`;

export const CardProductDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin-top: 4px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: 14px;
    }
  `}
`;

export const CardProductCtaWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.xxxs};
    margin-top: auto;
    padding: 0 ${theme.v3.spacing.xxs} ${theme.v3.spacing.xs};
  `}
`;

export const CardProductTag = styled.div`
  ${({ theme, $variant }) => css`
    background-color: ${theme.v3.colors.accent.green[70]};
    border-radius: ${theme.v3.border.radius.sm};
    color: ${theme.v3.colors.neutral[100]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: 24px;
    padding: 0 ${theme.v3.spacing.nano};
    position: absolute;
    right: 13px;
    top: -5px;

    ${$variant === 'info' && css`
      background: linear-gradient(90deg, #2E93EE 0%, #2E93EE 6.25%, #2F92ED 12.5%, #3091ED 18.75%, #3190EC 25%, #338EEB 31.25%, #358CE9 37.5%, #3789E8 43.75%, #3A86E6 50%, #3D83E4 56.25%, #417FE1 62.5%, #457BDF 68.75%, #4976DC 75%, #4E71D9 81.25%, #536CD5 87.5%, #5866D2 93.75%, #5E60CE 100%);
    `}
  `}
`;

export const WrapperPrice = styled.div`
  align-items: baseline;
  display: flex;
`;

export const ProductDiscountPrice = styled.span`
  ${({ theme }) => css`
    background: ${theme.v3.colors.contextual.active[98]};
    border-radius: 4px;
    color: ${theme.v3.colors.contextual.active[30]};
    font-size: 14px;
    font-weight: ${theme.v3.font.weights.medium};
    line-height: 24px;
    margin: 16px 0;
    padding: 0 8px;
  `}
`;

export const ProductPricePrefix = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: 16px;
    line-height: 1.2;
    margin-bottom: 8px;
  `}
`;

export const ProductSmallText = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: 14px;
    line-height: 18px;
  `}
`;

export const ProductPrice = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: 40px;
    font-weight: ${theme.v3.font.weights.medium};
    line-height: 1.2;
  `}
`;
